<template>
  <ZtLink
    class="teaser is-default is-horizontal has-tooltip is-third group-link"
    :to="url"
    :data-tooltip="text"
    draggable="false"
  >
    <div class="teaser-media">
      <slot name="media">
        <div
          v-blokkli-droppable:[editableConfig?.image]
          class="image aspect-4/3"
        >
          <MediaImage
            v-bind="media"
            responsive-style="column_third"
            no-draggable
          />
        </div>
      </slot>
    </div>
    <h2
      v-blokkli-editable:[editableConfig?.title]
      class="title text-balance"
      v-html="title"
    />

    <div
      v-if="tagline"
      v-blokkli-editable:[editableConfig?.tagline]
      class="subtitle mb-0"
      v-html="tagline"
    />

    <slot />

    <ClientOnly v-if="showOpeningHours && nid">
      <AddressOpeningHoursStatus :nid="nid" />
    </ClientOnly>

    <p
      v-if="text"
      v-blokkli-editable:[editableConfig?.text]
      class="teaser-text belowTablet:hidden"
      v-html="text"
    />

    <div
      v-blokkli-editable:[editableConfig?.linkTitle]
      class="link with-arrow belowTablet:hidden"
      v-html="linkTitle || $texts('teaserMore', 'More')"
    />
  </ZtLink>
</template>

<script lang="ts" setup>
import type { TeaserProps } from './types'

defineProps<TeaserProps>()
</script>

<style>
@reference '~/assets/css/tailwind.css';
.teaser.is-third {
  @apply text-size-6;
  @apply tablet:flex tablet:h-full tablet:flex-col;
  .title,
  .subtitle {
    @apply text-size-7;
    @apply tablet:text-size-5;
  }
  .opening-hours-status {
    @apply belowTablet:text-size-7;
    @variant belowTablet {
      margin-top: 0.5rem;
    }
  }
  .subtitle {
    @apply mb-0;
  }
  .title {
    @apply mt-size-7 mb-0;
    @apply tablet:mt-size-6;
  }
  .teaser-text {
    @apply mb-size-6;
  }

  .link {
    @apply mt-auto text-size-6;
  }
}

.teaser-text {
  @apply text-scheme-invert-ter;
}
</style>
